var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './Blocks.module.css';
import { TooltipSimple } from '../TooltipSimple/TooltipSimple';
var getItemStyle = function (isDragging, draggableStyle) { return (__assign({ 
    // some basic styles to make the items look a bit nicer
    userSelect: 'none', background: isDragging ? 'whitesmoke' : 'white' }, draggableStyle)); };
export default function Blocks(_a) {
    var items = _a.items, updateItems = _a.updateItems, children = _a.children, canChangeLength = _a.canChangeLength, defaultItemConstructor = _a.defaultItemConstructor, isValid = _a.isValid, validationMessage = _a.validationMessage, style = _a.style, blockTitle = _a.blockTitle, addButtonTitle = _a.addButtonTitle, maxBlocks = _a.maxBlocks, minBlocks = _a.minBlocks, tooltip = _a.tooltip, onDelete = _a.onDelete, _b = _a.tooltipCloseOnScroll, tooltipCloseOnScroll = _b === void 0 ? false : _b;
    var reorder = function (list, startIndex, endIndex) {
        var result = Array.from(list);
        var _a = __read(result.splice(startIndex, 1), 1), removed = _a[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var onDragEnd = function (result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        updateItems(reorder(items, result.source.index, result.destination.index));
    };
    var lessThanMax = maxBlocks ? items.length < maxBlocks : true;
    var moreThanMin = items.length > (minBlocks !== null && minBlocks !== void 0 ? minBlocks : 1);
    return (React.createElement(React.Fragment, null,
        React.createElement(DragDropContext, { onDragEnd: onDragEnd },
            React.createElement(Droppable, { droppableId: 'droppable' }, function (provided) {
                var _a;
                return (React.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef, className: styles.container, style: style }),
                    items.map(function (item, index) {
                        var updateItem = function (value) {
                            var nextItems = items.slice();
                            nextItems.splice(index, 1, __assign(__assign({}, item), value));
                            updateItems(nextItems);
                        };
                        return (React.createElement(React.Fragment, { key: "fragment_".concat(index) },
                            React.createElement(Draggable, { key: index, draggableId: "slide_".concat(index), index: index }, function (provided, snapshot) { return (React.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: styles.slide, style: getItemStyle(snapshot.isDragging, provided.draggableProps.style) }),
                                React.createElement("section", { className: styles.titleContainer },
                                    React.createElement("div", { className: styles.title }, blockTitle !== null && blockTitle !== void 0 ? blockTitle : 'Слайд',
                                        " ",
                                        index + 1),
                                    React.createElement("div", { style: {
                                            display: 'flex'
                                        } },
                                        tooltip && (React.createElement(TooltipSimple, { text: tooltip, style: {
                                                marginRight: '5px'
                                            } })),
                                        canChangeLength && moreThanMin && (React.createElement("button", { type: 'button', className: styles.deleteButton, onClick: function () {
                                                onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
                                                var newItems = items.slice();
                                                newItems.splice(index, 1);
                                                updateItems(newItems);
                                            } })))),
                                children(item, index, updateItem))); })));
                    }),
                    provided.placeholder,
                    canChangeLength && defaultItemConstructor && lessThanMax && (React.createElement("button", { type: 'button', onClick: function () {
                            return updateItems(__spreadArray(__spreadArray([], __read(items), false), [
                                defaultItemConstructor(items.length)
                            ], false));
                        }, className: styles.addButton },
                        "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
                        ' ',
                        addButtonTitle
                            ? addButtonTitle.toLowerCase()
                            : (blockTitle === null || blockTitle === void 0 ? void 0 : blockTitle.toLowerCase()) === 'страница'
                                ? 'страницу'
                                : (_a = blockTitle === null || blockTitle === void 0 ? void 0 : blockTitle.toLowerCase()) !== null && _a !== void 0 ? _a : 'слайд')),
                    isValid === false && (React.createElement("div", { className: styles.validationMessage }, validationMessage))));
            }))));
}
